import { reducer as deleteReport } from './deleteReport'
import { reducer as generateReport } from './generateReport'
import { reducer as getReports } from './getReports'
import { reducer as saveReport } from './saveReport'
import { reducer as updateReport } from './updateReport'
import { reducer as selectedReport } from './selectedReport'
import { reducer as getReport } from './getReport'
import { reducer as getReportParameters } from './getReportParameters'
import { reducer as generateReportPDF } from './generateReportPDF'
import { reducer as getIndividualReports } from './getIndividualReports'
import { reducer as getBulkReports } from './getBulkReports'
import { reducer as statusReports } from './statusReports'
import { reducer as getGeneratedReports } from './getGeneratedReports'
import { reducer as bulkReportsStop } from './bulkReportsStop'
import { reducer as bulkReportsClear } from './bulkReportsClear'
import { reducer as generateReportJSON } from './generateReportJSON'
import { reducer as bulkReportsDownloadAll } from './bulkReportsDownloadAll'
import { reducer as bulkReportsDownload } from './bulkReportsDownload'
import { reducer as bulkReportsDownloadAllPDF } from './bulkReportsDownloadAllPDF'
import { reducer as bulkReportsDownloadPDF } from './bulkReportsDownloadPDF'
import { reducer as generateFinishReport } from './generateFinishReport'
import { reducer as getStatusReport } from './getStatusReport'
import { reducer as getReportManagerList } from './getReportManagerList'
import { reducer as sendEmails } from './sendEmails'
import { reducer as continueSendEmails } from './continueSendEmails'
import { reducer as previewEmails } from './previewEmails'
import { reducer as sendEmailsCheck } from './sendEmailsCheck'
import { reducer as getReportsPowerBiToken } from './getReportsPowerBiToken'

export default {
  deleteReport,
  generateReport,
  getReports,
  saveReport,
  selectedReport,
  getReport,
  getReportParameters,
  updateReport,
  generateReportPDF,
  getBulkReports,
  getIndividualReports,
  statusReports,
  getGeneratedReports,
  bulkReportsStop,
  bulkReportsClear,
  generateReportJSON,
  bulkReportsDownloadAll,
  bulkReportsDownload,
  bulkReportsDownloadAllPDF,
  bulkReportsDownloadPDF,
  generateFinishReport,
  getStatusReport,
  getReportManagerList,
  sendEmailsCheck,
  previewEmails,
  continueSendEmails,
  sendEmails,
  getReportsPowerBiToken
}



// WEBPACK FOOTER //
// ./src/store/reports/index.js